import delay from '../hoc/delay';
import Component from './EditableArea';
import { compose } from '../utils/func';
import inputable from '../Form/inputable';
var EditableArea = compose(inputable, delay(400))(Component);
EditableArea.displayName = 'ShineoutEditableArea';
export default EditableArea;